// Bilingual string table for our UI. Falls back to EN.

const STRINGS = {
	en: {
		"Theme Settings": "Theme Settings",
		"Theme Colors": "Theme Colors",
		"Apply Color and Background": "Apply Color and Background",
		"Apply on Menu": "Apply on Menu",
		"Apply on Dashboard": "Apply on Dashboard",
		"Apply on Workspace": "Apply on Workspace",
		"Apply on Navbar": "Apply on Navbar",
		"Mode": "Mode",
		"Light": "Light",
		"Dark": "Dark",
		"Language": "Language",
		"Save Settings": "Save Settings",
		"Cancel": "Cancel",
		"Close": "Close",
		"Switch language": "Switch language",
		"Switch theme": "Switch theme",
		"Quick Actions": "Quick Actions",
		"Open Workbench": "Open Workbench",
		"Focus Mode": "Focus Mode",
		"Search commands…": "Search commands…",
		"No matches": "No matches",
		"Switch theme to": "Switch theme to",
		"Toggle dark mode": "Toggle dark mode",
		"Saved": "Saved",
		"Preparing your workspace…": "Preparing your workspace…",
		"Add Pane": "Add Pane",
		"Empty pane": "Empty pane",
		"Pick a doctype to load…": "Pick a doctype to load…",
	},
	ar: {
		"Theme Settings": "إعدادات الثيم",
		"Theme Colors": "ألوان الثيم",
		"Apply Color and Background": "تطبيق اللون والخلفية",
		"Apply on Menu": "تطبيق على القائمة",
		"Apply on Dashboard": "تطبيق على لوحة التحكم",
		"Apply on Workspace": "تطبيق على مساحة العمل",
		"Apply on Navbar": "تطبيق على شريط التنقل",
		"Mode": "الوضع",
		"Light": "فاتح",
		"Dark": "داكن",
		"Language": "اللغة",
		"Save Settings": "حفظ الإعدادات",
		"Cancel": "إلغاء",
		"Close": "إغلاق",
		"Switch language": "تبديل اللغة",
		"Switch theme": "تبديل الثيم",
		"Quick Actions": "إجراءات سريعة",
		"Open Workbench": "فتح مساحة العمل",
		"Focus Mode": "وضع التركيز",
		"Search commands…": "ابحث عن إجراء…",
		"No matches": "لا توجد نتائج",
		"Switch theme to": "تبديل الثيم إلى",
		"Toggle dark mode": "تبديل الوضع الداكن",
		"Saved": "تم الحفظ",
		"Preparing your workspace…": "جاري تحضير مساحة عملك…",
		"Add Pane": "إضافة لوحة",
		"Empty pane": "لوحة فارغة",
		"Pick a doctype to load…": "اختر نوع المستند…",
	},
};

const ACCENT_NAMES = {
	en: { blue: "Blue", green: "Green", red: "Red", orange: "Orange", yellow: "Yellow", pink: "Pink", violet: "Violet" },
	ar: { blue: "أزرق", green: "أخضر", red: "أحمر", orange: "برتقالي", yellow: "أصفر", pink: "وردي", violet: "بنفسجي" },
};

export function t(key, lang = "en") {
	return (STRINGS[lang] && STRINGS[lang][key]) || STRINGS.en[key] || key;
}

export function accentName(id, lang = "en") {
	return (ACCENT_NAMES[lang] && ACCENT_NAMES[lang][id]) || ACCENT_NAMES.en[id] || id;
}
